import * as z from 'zod';

export const secondaryContactSchema = z
  .object({
    firstName: z.string(),
    lastName: z.string(),
    phoneNumber: z.string(),
  })
  .superRefine((data, ctx) => {
    if (!data.firstName) {
      ctx.addIssue({ code: 'custom', message: 'Required Field', path: ['firstName'] });
    }
    if (!data.lastName) {
      ctx.addIssue({ code: 'custom', message: 'Required Field', path: ['lastName'] });
    }
    if (!data.phoneNumber) {
      ctx.addIssue({ code: 'custom', message: 'Required Field', path: ['phoneNumber'] });
    } else if (data.phoneNumber.length < 12) {
      ctx.addIssue({
        code: 'custom',
        message: 'Invalid Phone Number',
        path: ['phoneNumber'],
      });
    }
  });

export type SecondaryContactErrors = Partial<z.infer<typeof secondaryContactSchema>>;

export const addressResultSchema = z.object({
  placeId: z.string(),
  structuredFormatting: z.object({
    mainText: z.string(),
    secondaryText: z.string(),
  }),
});

export type AddressResult = z.infer<typeof addressResultSchema>;

export const daytimePhoneSchema = z
  .object({
    areaCode: z.string(),
    phoneNumber: z.string(),
    base: z.string().optional(),
    extensionNumber: z.string().optional(),
  })
  .optional();

export type DaytimePhone = z.infer<typeof daytimePhoneSchema>;

export const availableLocationSchema = z.object({
  locationNumber: z.string().optional(),
  name: z.string().optional(),
  locationContact: z.object({ daytimePhone: daytimePhoneSchema }).optional(),
});

export type AvailableLocation = z.infer<typeof availableLocationSchema>;
